












import Vue from "vue";
import { Prop, Component, Watch } from 'vue-property-decorator'
import { FramePuzzleModule, PuzzleFormat, PuzzleBoxState } from '@/store/modules/framePuzzle'
import { Design } from '@/rest'
import FrameImage from '@/components/products/framepuzzle/FrameImage.vue'

@Component({
  name: "tab",
  components: {
    FrameImage
  }
})
export default class Tab extends Vue {
  @Prop() private label!: string
  @Prop() private id!: number
  @Prop() private boxType!: string
  @Prop() private headerHeight!: number
  @Prop() private index!: number

  private designs: Design[] = []

  isSelectedDesign(id: number) {
    return FramePuzzleModule.boxDesign === id
  }

  onSelectDesign(id: number) {
    FramePuzzleModule.SetBoxDesign(id)
  }

  scrollContainerHeight() {
    return 345 - this.headerHeight
  }

  get availableDesigns() {
    return FramePuzzleModule.availableDesigns
  }

  sortList(list: Design[]) {
    return list.sort((a, b) => {
      return a.sort! - b.sort!;
    });
  }

  initTab() {
    for (let i = 0; i < FramePuzzleModule.availableDesigns.length; i++) {
      if (FramePuzzleModule.availableDesigns[i].length !== 0) {
        let categoryId = Number(FramePuzzleModule.availableDesigns[i][0].designCategories)
        let currentBox = FramePuzzleModule.availableDesigns[i][0].boxType
        if (categoryId === this.id && currentBox === this.boxType) {
          for (let j = 0; j < FramePuzzleModule.availableDesigns[i].length; j++) {
            let online = FramePuzzleModule.availableDesigns[i][j].online
            if (online) {
              this.designs.push(FramePuzzleModule.availableDesigns[i][j])
            }
          }
        }
      }
    }
    this.designs = this.sortList(this.designs)
  }

  mounted() {
    this.initTab()
  }

}
